import React from 'react';
import AdminNavbar from './admin_navbar';
import AdminSidebar from './admin_sidebar';

export default function AdminSettings() {
  return (
    <div className="min-h-screen flex flex-col bg-white font-poppins">
      <AdminNavbar />
      <div className="flex w-full">
        <AdminSidebar />
        <div className="flex-1 p-8 bg-gray-100">
          <h1 className="text-3xl font-bold mb-6">Admin Settings</h1>
          <p>Here you can update admin preferences, users, and website configurations.</p>
        </div>
      </div>
    </div>
  );
}
